import React, { useState, useRef, useEffect } from "react";
import { MoveRight } from "lucide-react";
import { CardProductProps } from "./CardProductProps";
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";


const CardProduct: React.FC<CardProductProps & WithTranslationProps> = ({
    img,
    brand,
    name,
    sku,
    price,
    currency,
    quantity,
    link,
    width,
    height,
    t
}) => {
    const titles = ["Products.BrandTitle", "Products.StockTitle"]

    return (
        <React.Fragment>
            <div
                className="relative transition-all duration-300 ease-linear card hover:-translate-y-2 dark:bg-zink-600 shadow-2xl"                
            >
                <a href={link}>
                    <div className="p-3 flex flex-col justify-center items-center">
                        {img && (
                            <img
                                width={width ?? -1}
                                height={height ?? -1}
                                src={img}
                                alt=""
                            />
                        )}
                        {brand && (<div className="mt-1">
                            
                            <h6
                                className="text-center text-xs sm:text-xs md:text-sm"
                            >
                                {t(titles[0])}: {brand}
                            </h6>                            
                        </div>)}
                        {name && (<div className="mt-1">
                            
                                <h6
                                    className="text-center text-xs sm:text-xs md:text-sm"
                                >
                                    {name}
                                </h6>                            
                        </div>)}
                        {sku && (<div className="mt-1">
                            <h6
                                className="text-center text-xs sm:text-xs md:text-sm text-blue-800"
                            >
                                {sku}
                            </h6>
                        </div>)}
                        {price && (<div className="mt-1">
                            <h6
                                className="text-center text-xs sm:text-xs md:text-sm text-black"
                            >
                                ${price} + {t("Products.Tax")}
                            </h6>
                        </div>)}
                        <div className="mt-1">
                            <h6
                                className={`text-center text-xs sm:text-xs md:text-sm ${quantity ? "text-green-500" : "text-red-500"}`}
                            >
                                {t(titles[1])}: {quantity}
                            </h6>
                        </div>
                    </div>
                </a>
            </div>
        </React.Fragment>
    );
};

export default withTranslation(CardProduct);
